/** When your routing table is too long, you can split it into small modules **/

// import Layout from '@/layout'

const filesRouter = {
    path: '/',
    component: () => import('@/views/base/Index'),
    children: [
      {
        name: '打印证明',
        path: 'file',
        component: () => import('@/views/file/List'),
      },
      {
        name: '打印拆迁证明',
        path: 'file/remove',
        component: () => import('@/views/file/PrintRemove'),
      },
      {
        name: '打印宅基地证明',
        path: 'file/homestead',
        component: () => import('@/views/file/PrintHomestead'),
      },
      {
        name: '打印安置房退还储藏室申请',
        path: 'file/sub',
        component: () => import('@/views/file/PrintSub'),
      },
      {
        name: '打印公积金证明',
        path: 'file/fund',
        component: () => import('@/views/file/PrintFund'),
      },
      {
        name: '打印结清临时安置补助费的证明',
        path: 'file/subsidy',
        component: () => import('@/views/file/PrintSubsidy'),
      },

      
    ],
  }
  
  export default filesRouter